import axios from 'axios';

/** Remove códigos internos tipo "RN21:" das mensagens exibidas ao usuário (rede de segurança). */
export function sanitizeUserFacingMessage(message: string): string {
  const s = message
    .replace(/\bRN\d+:\s*/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
  return s.length > 0 ? s : 'Não foi possível completar a operação.';
}

function messageFromAxiosResponseData(data: unknown): string | null {
  if (data == null) return null;
  if (typeof data === 'string' && data.trim()) return data.trim();
  if (typeof data !== 'object') return null;
  const o = data as Record<string, unknown>;
  const m = o.message;
  if (typeof m === 'string' && m.trim()) return m.trim();
  if (Array.isArray(m) && m.length > 0) {
    return m.map((x) => String(x)).join(' ').trim() || null;
  }
  return null;
}

/**
 * Mensagem amigável para toast / UI.
 * Em erros Axios, usa sempre o corpo da API (`message`), não `error.message` (ex.: "Request failed with status code 400").
 */
export function getApiErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err) && err.response?.data !== undefined) {
    const fromBody = messageFromAxiosResponseData(err.response.data);
    if (fromBody) return sanitizeUserFacingMessage(fromBody);
  }
  if (err instanceof Error) return sanitizeUserFacingMessage(err.message);
  return 'Não foi possível completar a operação.';
}
